import * as React from "react"
import { Container, Modal, Form, Button, Row, Col, Table } from "react-bootstrap"

export interface AddressData {
  ID: string
  Address1: string
  Zip: string
}

interface AddressMatchModalProps {
  show: boolean
  addresses: AddressData[]
  selectedID?: string
  title: string
  subTitle: string
  message?: string
  onClose: () => void
  onAddressSelect: (address: AddressData) => void
}

export default class AddressMatchModal extends React.PureComponent<AddressMatchModalProps> {
  render() {
    const { addresses, selectedID, title, subTitle, message } = this.props
    return (
      <Modal centered backdrop="static" size="lg" show={this.props.show} onHide={this.props.onClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container fluid>
            <Row><Col><h5>{subTitle}</h5></Col></Row>
            <Row><Col>
              <Table className="table-sm dark" responsive>
                <thead>
                  <tr>
                    <th>&nbsp;</th>
                    <th>Street Address</th>
                    <th>Zip</th>
                  </tr>
                </thead>
                <tbody>
                  {addresses.map(item => <tr key={item.ID}>
                    <td className="text-center">
                      <Form.Check type="radio" label="" id={`streetAddress_${item.ID}`} checked={item.ID === selectedID} className="abc-radio" onChange={() => this.props.onAddressSelect(item)} />
                    </td>
                    <td>{item.Address1}</td>
                    <td>{item.Zip}</td>
                  </tr>)}
                </tbody>
              </Table>
            </Col></Row>
            <Row><Col>{message}</Col></Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.props.onClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}
